import { Skeleton } from "@r360/library";
import React from "react";
import useAppSelector from "../../hooks/useAppSelector";
import { TSearch } from "../../store/types";
import { requestLoadingByResvTypeSelector } from "../../Selectors";
import useTranslate from "../../hooks/useTranslate";

type TSearchResultInfo = {
    searchResult: TSearch;
};

export const SearchResultInfo = ({ searchResult }: TSearchResultInfo) => {
    const t = useTranslate();
    const isSearching = useAppSelector(state =>
        requestLoadingByResvTypeSelector(state, "fetchReservationTypeResults", searchResult?.type)
    );

    if (!searchResult) {
        return null;
    }

    const { guests, arrdate, depdate } = searchResult;
    const searchIncludesGuests = guests.length > 0;

    if (!searchIncludesGuests) {
        return null;
    }

    if (isSearching) {
        return <Skeleton />;
    }

    if (searchIncludesGuests) {
        return (
            <div>
                <p>
                    {t(guests.length > 1 ? "book.showing_result_with_guests" : "book.showing_result_with_guest", [
                        guests.length,
                        arrdate,
                        depdate,
                    ])}
                </p>
            </div>
        );
    }

    return <div>{t("book.showing_result", [arrdate, depdate])}</div>;
};
